'use client';

import { FC, useRef } from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import styles from './Map.module.scss';
import type { CenteredMode, IMapsProps } from './map.types';
import { useGoogleMap } from './useGoogleMap';

const REVERSE_PROXY_LINK = process.env.NEXT_PUBLIC_REVERSE_PROXY_LINK ?? '';

const centeredStyleMap: Record<CenteredMode, string> = {
  center: 'centered-center',
  left: 'centered-left',
  SE: 'centered-se',
  rigth: 'centered-rigth',
};

const Maps: FC<IMapsProps> = ({
  actionClickMarker,
  locations,
  className,
  context = 'Map',
  centered = 'center',
  hideInterestingPoints = false,
  openInfo = true,
  showTitle = true,
  pinColor,
  mapStyleTokens = 'brand',
  defaultMarker,
  markerStyle,
  narrowMapTooltip = false,
  zoom = 12,
}) => {
  const ref = useRef<HTMLElement | null>(null);

  const isDarkMode = mapStyleTokens === 'dark';
  const isInvertedMode = mapStyleTokens === 'inverted';

  useGoogleMap(ref, {
    locations,
    mapStyleTokens,
    hideInterestingPoints,
    centered,
    zoom,
    context,
    openInfo,
    showTitle,
    narrowMapTooltip,
    pinColor,
    defaultMarker,
    markerStyle,
    actionClickMarker,
  });

  return (
    <figure
      className={classNames(
        styles['map-multilocation'],
        styles[centeredStyleMap[centered]],
        className,
      )}
      ref={ref}
    >
      {locations.length ? null : (
        <>
          <Image
            alt="Default map"
            className={styles.default_map}
            fill
            sizes="100vw"
            src={
              isDarkMode || isInvertedMode
                ? `${REVERSE_PROXY_LINK}/images/default_map_dark.png`
                : `${REVERSE_PROXY_LINK}/images/default_map.png`
            }
          />
          <div className={styles.empty_locations_square}>
            <i
              className={classNames('icon icon_search', styles.search_icon)}
            ></i>
            <span className={styles.title}>No stores available</span>
            <p className={styles.message}>
              There are no available stores in this area. Please try again to
              find a new store
            </p>
          </div>
        </>
      )}
    </figure>
  );
};

export default Maps;
